import posthog from "posthog-js";
import { initAnalytics } from "@regexsolver/web-shared/analytics";

// Shared setup across website/console/docs (see apps/web-shared/src/analytics.ts):
// cookieless anonymous capture by default, upgraded to persistent cookies when the
// cross-subdomain consent cookie says "accepted". Imported for its side effect from
// mount-cookie-banner.ts; no-op during build-time prerendering (Node) or when
// ZUDOKU_PUBLIC_POSTHOG_PROJECT_TOKEN is unset (e.g. bare local dev).
initAnalytics(posthog, {
  token: process.env.ZUDOKU_PUBLIC_POSTHOG_PROJECT_TOKEN,
  apiHost: process.env.ZUDOKU_PUBLIC_POSTHOG_HOST,
  source: "docs",
});
